import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createAgent } from "../../redux/actions/agents";
import { redirect } from "../../redux/actions/agents";

export default function AddAgent() {
  const initialData = {
    name: "",
    address: "",
    phoneNo: "",
    loan: "",
    loanStatus: "green",
    agentSince: null,
  };
  const [inputData, setInputData] = useState(initialData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const { isLoading } = useSelector((state) => state.agents);

  useEffect(() => {
    if (!isLoading) {
      navigate(`/manager/agents`);
      dispatch(redirect());
    }
  }, [dispatch, isLoading, navigate]);

  const handleRegisterAgent = (e) => {
    e.preventDefault();
    dispatch(createAgent({ inputData }));
  };

  return (
    <>
      <div className="flex bg-white">
        <div className="flex-1 flex flex-col pt-6 justify-center px-4 sm:px-6 lg:px-20 xl:px-24">
          <div className="mx-auto w-full">
            <div className="px-5 sm:px-8 lg:px-36">
              {" "}
              <form className="space-y-8 divide-y divide-gray-200">
                <div className="space-y-8 divide-y divide-gray-200">
                  <div>
                    <div>
                      <h3 className="text-lg leading-6 font-medium text-gray-900">
                        Add Agent
                      </h3>
                      <p className="mt-1 text-sm text-gray-500">
                        Fill out the information.
                      </p>
                    </div>

                    <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                      <div className="sm:col-span-3">
                        <label
                          htmlFor="last-name"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Full name
                        </label>
                        <div className="mt-1">
                          <input
                            type="text"
                            name="name"
                            id="last-name"
                            value={inputData.name}
                            autoComplete="family-name"
                            onChange={handleChange}
                            className="shadow-sm focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-none block w-full sm:text-sm px-3 py-2 border border-gray-300 rounded-md"
                          />
                        </div>
                      </div>

                      <div className="sm:col-span-3">
                        <label
                          htmlFor="email"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Address
                        </label>
                        <div className="mt-1">
                          <input
                            id="email"
                            name="address"
                            type="text"
                            value={inputData.address}
                            autoComplete="email"
                            onChange={handleChange}
                            className="shadow-sm focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-none block w-full sm:text-sm px-3 py-2 border border-gray-300 rounded-md"
                          />
                        </div>
                      </div>
                      <div className="sm:col-span-3">
                        <label
                          htmlFor="tel"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Phone number
                        </label>
                        <div className="mt-1">
                          <input
                            id="tel"
                            name="phoneNo"
                            type="tel"
                            value={inputData.phoneNo}
                            autoComplete="tel"
                            onChange={handleChange}
                            className="shadow-sm focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-none block w-full sm:text-sm px-3 py-2 border border-gray-300 rounded-md"
                          />
                        </div>
                      </div>
                      <div className="sm:col-span-3">
                        <label
                          htmlFor="tel"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Loan
                        </label>
                        <div className="mt-1">
                          <input
                            id="tel"
                            name="loan"
                            type="number"
                            value={inputData.loan}
                            autoComplete="tel"
                            onChange={handleChange}
                            className="shadow-sm focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-none block w-full sm:text-sm px-3 py-2 border border-gray-300 rounded-md"
                          />
                        </div>
                      </div>
                      <div className="sm:col-span-3">
                        <label
                          htmlFor="tel"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Loan Status
                        </label>
                        <select
                          onChange={handleChange}
                          name="loanStatus"
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-teal-500 focus:border-teal-500 sm:text-sm"
                        >
                          <option value="green">Green</option>
                          <option value="yellow">Yellow</option>
                          <option value="red">Red</option>
                        </select>
                      </div>
                      <div className="sm:col-span-3">
                        <label
                          htmlFor="orderNo"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Agent Since
                        </label>
                        <div className="mt-1">
                          <input
                            type="date"
                            name="agentSince"
                            className="shadow-sm flex-grow  focus:ring-sky-500 focus:border-sky-500 flex w-full sm:w-160 md:w-160 lg:w-160 sm:text-sm border-gray-300 rounded-md"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="pt-5">
                  <div className="flex justify-end">
                    <button
                      type="button"
                      className="bg-white px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      onClick={handleRegisterAgent}
                      className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
